import React, {Component} from 'react';
import TopHeader from '../template/TopHeader';
import {bookingActions, hairdresserActions, userActions} from "../../_actions";
import {connect} from "react-redux";
import DatePicker from "react-datepicker";
import dateFormat from "dateformat";
import PhoneInput from "react-phone-number-input";
import moment from 'moment';
import './ClientDetail.css';
import MergeClientsPanel from './MergeClientsPanel';

//var ObjectId = require('mongoose').Types.ObjectId;

    class EditClient extends Component {
        constructor(props) {
            super(props);

            this.state = {
                name:'',
                first_name:'',
                last_name:'',
                email:'',
                phoneNumber:'',
                note:'',
                emailMarketingConsent: false,
                smsMarketingConsent: false,
                dob:'',
                error:'',
                isEmail:true,
                showEmail:'',
                mergeSuggestion: null,
                showMergeModal: false
            }
            this.editClient=this.editClient.bind(this);
            this.selectDob=this.selectDob.bind(this);
            this.cancelClient=this.cancelClient.bind(this);
            this.onChanged=this.onChanged.bind(this);
            this.getPhoneNumber=this.getPhoneNumber.bind(this);

        }

        fetchClientDetails() {
            var self = this;
            self.props.dispatch(hairdresserActions.getHairdresserClientDetail({
                'userId': this.props.match.params.id,
                'hairdresserId':localStorage.getItem('userId'),
                'bookingType':self.state.bookingType,
            }))
            .then(function (response) {
                console.log('client response', response);
                // Handle v2 API response structure
                const clientDetail = response.data?.responseData?.clientDetail || response.data?.data?.clientDetail;
                if(clientDetail){
                    let phoneNumber=clientDetail.phoneNumber?self.getPhoneNumber(clientDetail.phoneNumber):"";
                    console.log("phoneNumber",phoneNumber);

                    let email=clientDetail?.email;
                    let emailArr=email?.split('@');
                    if(emailArr?.[1]==='beuapp.com'){
                        self.setState({
                            isEmail:false,
                            showEmail:''
                        })
                    }else{
                        self.setState({
                            showEmail:email
                        })
                    }
                    self.setState({
                        first_name:clientDetail.first_name&&clientDetail.first_name!=""?clientDetail.first_name:clientDetail.name,
                        last_name:clientDetail.last_name,
                        email:clientDetail?.email,
                        phoneNumber:phoneNumber,
                        note:clientDetail.note,
                        // Raw tri-state: true / false / null (never asked). Coercing
                        // null to false here made every unrelated save silently write
                        // consent=false — an accidental opt-out.
                        emailMarketingConsent: clientDetail.emailMarketingConsent ?? null,
                        smsMarketingConsent: clientDetail.smsMarketingConsent ?? null,
                    })
                    if(clientDetail.dob&&clientDetail.dob!==""){
                        self.setState({
                            dob:new Date(moment(clientDetail.dob,'DD-MM-YYYY'))
                        })
                    }

                }
            })
        }

        componentDidMount() {
            var self = this;
            let params = {
                defaultRedirectTo:localStorage.getItem('defaultRedirectTo')
            };
            if (localStorage.getItem('accessToken')) {
                self.props.dispatch(userActions.profile(params))
                this.fetchClientDetails();
            }else{
                this.props.history.push('/')
            }
        }

        componentDidUpdate(prevProps) {
            // Refetch client details if the client ID in the URL changes
            if (prevProps.match.params.id !== this.props.match.params.id) {
                this.fetchClientDetails();
            }
        }

        editClient(){
            let self = this;
            let params = {};
            params.hairdresserId = localStorage.getItem('userId');
            params.userId = this.props.match.params.id;
            params.name=this.state.first_name+" "+this.state.last_name;
            params.first_name=this.state.first_name;
            params.last_name=this.state.last_name;
            params.email=this.state.email;
            params.phoneNumber=this.state.phoneNumber;
            params.note=this.state.note;
            params.dob=this.state.dob?dateFormat(this.state.dob, 'dd-mm-yyyy'):""
            // Only send consent the salon actually set — an untouched null
            // (never asked, marketable-by-default) must stay null.
            if (typeof this.state.emailMarketingConsent === 'boolean') params.emailMarketingConsent = this.state.emailMarketingConsent;
            if (typeof this.state.smsMarketingConsent === 'boolean') params.smsMarketingConsent = this.state.smsMarketingConsent;

            if (this.state.first_name === "" || this.state.first_name === undefined) {
                this.setState({
                    fNameError: 'Please enter first name'
                })
            }
            // else if (this.state.last_name === "" || this.state.last_name === undefined) {
            //     this.setState({
            //         lNameError: 'Please enter last name'
            //     })
            // }
            // else if (this.state.email === "" || this.state.email === undefined) {
            //     this.setState({
            //         emailError: "Please enter email address"
            //     })
            // }
            else if (this.state.email !== ""&&!this.validateEmail(this.state.email)) {
                this.setState({
                    emailError: 'Please enter a valid email address'
                })
            } else {
                self.props.dispatch(hairdresserActions.editClient(params))
                    .then(function (response) {
                        if (response.data.errorCode) {
                            if(response.data.errorCode==51){
                                self.setState({
                                    emailError: response.data.messages
                                })
                            }else{
                                self.setState({
                                    error: response.data.messages
                                })
                            }
                        } else {
                            // §7.3 — BE returns a mergeSuggestion when the
                            // edited email matches an existing User. Don't
                            // navigate away; show the suggestion banner so
                            // the salon can opt-in.
                            const responseData = response.data?.responseData || response.data?.data;
                            const suggestion = responseData?.mergeSuggestion;
                            if (suggestion && suggestion.matchingUserId) {
                                self.setState({ mergeSuggestion: suggestion });
                            } else {
                                self.props.history.push('/clients');
                            }
                        }
                    })
            }
        }

        selectDob(e){
            this.setState({dob:e})
        }

        cancelClient(){
            this.props.history.push('/clients/'+this.props.match.params.id)
        }

        onChanged(e) {
            this.setState({ [e.target.name]: e.target.value, copied: false });

            if (e.target.name === 'email') {
                this.setState({
                    showEmail:e.target.value
                })
                if (!this.validateEmail(e.target.value)) {
                    this.setState({
                        emailError: 'Please enter a valid email address'
                    })
                } else {
                    this.setState({
                        emailError: ''
                    })
                }
            }

            if (e.target.name === 'first_name') {
                if (e.target.value === '' || e.target.value === null) {
                    this.setState({
                        fNameError: ''
                    })
                } else {
                    this.setState({
                        fNameError: '',
                    })
                }
            }

            if (e.target.name === 'last_name') {
                if (e.target.value === '' || e.target.value === null) {
                    this.setState({
                        lNameError: ''
                    })
                } else {
                    this.setState({
                        lNameError: '',
                    })
                }
            }
        }

        validateEmail(email) {
            const pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const result = pattern.test(email);
            return result;
        }

        handlePhoneChange = val => {
            this.setState({phoneNumber: val})
            // if(!isValidPhoneNumber(val)) {
            //     this.setState({
            //         phoneNumberError: 'Please enter a valid phone number'
            //     })
            // }
        }

        getPhoneNumber(phoneNumber){
            let phone=phoneNumber.toString()
            console.log("phone",phone);
            if(phone.length===5){
                console.log("phone1",phone);
                if (phone[0] === 0||phone[0] === "0") {
                    console.log("phone1.1",phone);
                    return "+44"+phone.substr(1)
                }else{
                    console.log("phone1.2",phone);
                    return "+44"+phone
                }
            }else {
                console.log("phone2",phone);
                if (phone[0] === 0||phone[0] === "0") {
                    console.log("phone2.1",phone);
                    return "+44"+phone.substr(1)
                } else if (phone[0] === 4||phone[0] === "4") {
                    console.log("phone2.2",phone);
                    return "+" + phone
                }  else if (phone[0] === 4||phone[0] === "+") {
                    console.log("phone2.3",phone);
                    return phone
                } else {
                    console.log("phone2.4",phone);
                    return "+44"+phone
                }
            }
        }




render() {
    console.log("this.prop", this.props);
    const clientDetail = this.props.clientDetail?.clientDetail;
    
    return(
        <div className="h_n">
            <div className="body_container cm_bg_white">
                <TopHeader
                    title={clientDetail ? "Edit " + clientDetail.name : "Edit Client"}
                    cancelButton={true}
                    cancelButtonText="Cancel"
                    previousPageUrl={"/clients/" + this.props.match.params.id}
                    {...this.props}
                />

                <div className="container client-detail-modern">
                    {/* Edit Client Form Card */}
                    <div className="section-card">
                        <div className="section-header">
                            <h2 className="section-title">Client Information</h2>
                        </div>

                        {this.state.error && (
                            <div className="alert alert-danger mb-4" role="alert">
                                <i className="fa fa-exclamation-circle mr-2"></i>
                                {this.state.error}
                            </div>
                        )}

                        {this.state.mergeSuggestion && (
                            <div className="alert mb-4" role="alert" style={{
                                background: '#e7f5ff',
                                border: '1px solid #74c0fc',
                                color: '#0b3d56',
                                padding: '14px 16px',
                                borderRadius: '8px'
                            }}>
                                <div style={{ fontWeight: 600, marginBottom: '6px' }}>
                                    This email matches an existing Beu account
                                </div>
                                <div style={{ marginBottom: '10px' }}>
                                    {this.state.mergeSuggestion.message} {this.state.mergeSuggestion.matchingUserName ? `(${this.state.mergeSuggestion.matchingUserName})` : ''}
                                </div>
                                <button
                                    onClick={() => this.setState({ showMergeModal: true })}
                                    style={{
                                        padding: '8px 16px',
                                        border: 'none',
                                        background: '#007EA0',
                                        color: '#fff',
                                        borderRadius: '6px',
                                        fontWeight: 600,
                                        marginRight: '8px'
                                    }}
                                >
                                    Link records
                                </button>
                                <button
                                    onClick={() => {
                                        this.setState({ mergeSuggestion: null });
                                        this.props.history.push('/clients');
                                    }}
                                    style={{
                                        padding: '8px 16px',
                                        border: '1px solid #ccc',
                                        background: '#fff',
                                        color: '#333',
                                        borderRadius: '6px'
                                    }}
                                >
                                    Not now
                                </button>
                            </div>
                        )}

                        {this.state.showMergeModal && this.state.mergeSuggestion && (
                            <MergeClientsPanel
                                initialWinnerUserId={this.state.mergeSuggestion.winnerUserId}
                                initialLoserUserId={this.state.mergeSuggestion.loserUserId}
                                onClose={() => this.setState({ showMergeModal: false })}
                                onConfirmed={() => {
                                    this.setState({ showMergeModal: false, mergeSuggestion: null });
                                    this.props.history.push('/clients');
                                }}
                            />
                        )}

                        <div className="row">
                            <div className="col-md-6 form-group">
                                <label className="form-label-modern">First Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control form-control-modern"
                                    name="first_name"
                                    value={this.state.first_name}
                                    onChange={this.onChanged}
                                    placeholder="Enter first name"
                                />
                                {this.state.fNameError && (
                                    <span className="error-message-modern">
                                        <i className="fa fa-exclamation-circle mr-1"></i>
                                        {this.state.fNameError}
                                    </span>
                                )}
                            </div>

                            <div className="col-md-6 form-group">
                                <label className="form-label-modern">Surname</label>
                                <input
                                    type="text"
                                    className="form-control form-control-modern"
                                    name="last_name"
                                    value={this.state.last_name}
                                    onChange={this.onChanged}
                                    placeholder="Enter surname"
                                />
                                {this.state.lNameError && (
                                    <span className="error-message-modern">
                                        <i className="fa fa-exclamation-circle mr-1"></i>
                                        {this.state.lNameError}
                                    </span>
                                )}
                            </div>

                            <div className="col-md-6 form-group">
                                <label className="form-label-modern">Email</label>
                                <input
                                    type="email"
                                    className="form-control form-control-modern"
                                    name="email"
                                    value={this.state.showEmail}
                                    onChange={this.onChanged}
                                    placeholder="Enter email address"
                                />
                                {this.state.emailError && (
                                    <span className="error-message-modern">
                                        <i className="fa fa-exclamation-circle mr-1"></i>
                                        {this.state.emailError}
                                    </span>
                                )}
                            </div>

                            <div className="col-md-6 form-group cm_PhoneInput">
                                <label className="form-label-modern">Mobile Number</label>
                                <PhoneInput
                                    international={true}
                                    defaultCountry="GB"
                                    country={"GB"}
                                    className="form-control form-control-modern"
                                    name="phoneNumber"
                                    placeholder="Enter phone number"
                                    value={this.state.phoneNumber}
                                    onChange={this.handlePhoneChange}
                                />
                            </div>

                            <div className="col-md-12 form-group">
                                <label className="form-label-modern">Birthday</label>
                                <div className="cm_full_date">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.dob}
                                        onChange={this.selectDob.bind(this)}
                                        className="form-control form-control-modern"
                                        placeholderText="Select birthday"
                                    />
                                </div>
                            </div>

                            <div className="col-md-12 form-group">
                                <label className="form-label-modern">Notes</label>
                                <textarea
                                    className="form-control form-control-modern"
                                    rows="6"
                                    name="note"
                                    value={this.state.note}
                                    onChange={this.onChanged}
                                    placeholder="Add any notes about this client..."
                                ></textarea>
                            </div>

                            <div className="col-md-12 form-group">
                                <label className="form-label-modern">Marketing permission</label>
                                <p style={{ fontSize: '13px', color: '#8E8E93', margin: '0 0 10px' }}>
                                    Clients receive marketing by default. Untick to stop marketing to this client. They can change their mind at any time.
                                </p>
                                <div className="form-check" style={{ marginBottom: '6px' }}>
                                    <input className="form-check-input" type="checkbox" id="emailMarketingConsent" checked={this.state.emailMarketingConsent !== false} onChange={(e) => this.setState({ emailMarketingConsent: e.target.checked })} />
                                    <label className="form-check-label" htmlFor="emailMarketingConsent">Email marketing</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="smsMarketingConsent" checked={this.state.smsMarketingConsent !== false} onChange={(e) => this.setState({ smsMarketingConsent: e.target.checked })} />
                                    <label className="form-check-label" htmlFor="smsMarketingConsent">SMS marketing</label>
                                </div>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="form-actions-modern">
                            <button
                                className="btn btn-outline-modern btn-lg"
                                onClick={this.cancelClient.bind(this)}
                            >
                                <i className="fa fa-times mr-2"></i>
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary-modern btn-lg"
                                onClick={this.editClient.bind(this)}
                            >
                                <i className="fa fa-check mr-2"></i>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
    }

function mapStateToProps(state) {
    return {
        ...state
    };
}

export default connect(mapStateToProps)(EditClient);
